import React from 'react';
import styles from './dayCell.module.css';

function DayCell({ date, isCurrentMonth, isAvailable, isSelected, onSelect }) {
    const dayNumber = date.getDate();

    const className = [
        styles.cell,
        !isCurrentMonth && styles.outsideMonth,
        isAvailable && styles.available,
        isSelected && styles.selected,
    ].filter(Boolean).join(' ');

    return (
        <button
            type="button"
            className={className}
            disabled={!isAvailable}
            onClick={onSelect}
            aria-pressed={isSelected}
        >
            <span className={styles.dayNumber}>{dayNumber}</span>
            {isAvailable && <span className={styles.availabilityDot} />}
        </button>
    );
}

export default DayCell;
